export const FLOOR_PLANS = [
  {
    slug: "1a-a",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "873 sq ft",
    balcony: "147–158 sq ft",
    bua: "1107–1118 sq ft",
    sbua: "1476–1491 sq ft",
    tower: "Tower 1A · Type A",
    planImage: "/assets/plan-1a-a.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1a-b",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "596 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 1A · Type B",
    planImage: "/assets/plan-1a-b.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "1a-c",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "826 sq ft",
    balcony: "134–149 sq ft",
    bua: "1048–1064 sq ft",
    sbua: "1398–1418 sq ft",
    tower: "Tower 1A · Type C",
    planImage: "/assets/plan-1a-c.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1a-d",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "829 sq ft",
    balcony: "133–152 sq ft",
    bua: "1049–1068 sq ft",
    sbua: "1399–1424 sq ft",
    tower: "Tower 1A · Type D",
    planImage: "/assets/plan-1a-d.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1a-e",
    category: "3 BHK Smart",
    config: "3 BHK 2T (Smart)",
    carpet: "703 sq ft",
    balcony: "82–99 sq ft",
    bua: "854–871 sq ft",
    sbua: "1138–1162 sq ft",
    tower: "Tower 1A · Type E",
    planImage: "/assets/plan-1a-e.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1a-f",
    category: "3 BHK Comfort",
    config: "3 BHK 2T (Comfort)",
    carpet: "774 sq ft",
    balcony: "87–101 sq ft",
    bua: "938–951 sq ft",
    sbua: "1250–1268 sq ft",
    tower: "Tower 1A · Type F",
    planImage: "/assets/plan-1a-f.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1a-g",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "595 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 1A · Type G",
    planImage: "/assets/plan-1a-g.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "1a-h",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "879 sq ft",
    balcony: "147–157 sq ft",
    bua: "1109–1119 sq ft",
    sbua: "1479–1492 sq ft",
    tower: "Tower 1A · Type H",
    planImage: "/assets/plan-1a-h.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1b-a",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "877 sq ft",
    balcony: "146–157 sq ft",
    bua: "1106–1117 sq ft",
    sbua: "1475–1490 sq ft",
    tower: "Tower 1B · Type A",
    planImage: "/assets/plan-1b-a.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1b-b",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "596 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 1B · Type B",
    planImage: "/assets/plan-1b-b.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "1b-c",
    category: "3 BHK Comfort",
    config: "3 BHK 2T (Comfort)",
    carpet: "783 sq ft",
    balcony: "97 sq ft",
    bua: "955 sq ft",
    sbua: "1274 sq ft",
    tower: "Tower 1B · Type C",
    planImage: "/assets/plan-1b-c.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1b-d",
    category: "3 BHK Smart",
    config: "3 BHK 2T (Smart)",
    carpet: "703 sq ft",
    balcony: "82–99 sq ft",
    bua: "852–870 sq ft",
    sbua: "1136–1160 sq ft",
    tower: "Tower 1B · Type D",
    planImage: "/assets/plan-1b-d.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1b-e",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "826 sq ft",
    balcony: "154 sq ft",
    bua: "1065 sq ft",
    sbua: "1420 sq ft",
    tower: "Tower 1B · Type E",
    planImage: "/assets/plan-1b-e.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1b-f",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "823 sq ft",
    balcony: "138–159 sq ft",
    bua: "1050–1070 sq ft",
    sbua: "1400–1426 sq ft",
    tower: "Tower 1B · Type F",
    planImage: "/assets/plan-1b-f.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "1b-g",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "597 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 1B · Type G",
    planImage: "/assets/plan-1b-g.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "1b-h",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "874 sq ft",
    balcony: "146–157 sq ft",
    bua: "1108–1119 sq ft",
    sbua: "1477–1492 sq ft",
    tower: "Tower 1B · Type H",
    planImage: "/assets/plan-1b-h.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2a-a",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "873 sq ft",
    balcony: "147–158 sq ft",
    bua: "1107–1118 sq ft",
    sbua: "1476–1491 sq ft",
    tower: "Tower 2A · Type A",
    planImage: "/assets/plan-2a-a.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2a-b",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "596 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 2A · Type B",
    planImage: "/assets/plan-2a-b.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "2a-c",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "826 sq ft",
    balcony: "134–149 sq ft",
    bua: "1048–1064 sq ft",
    sbua: "1398–1418 sq ft",
    tower: "Tower 2A · Type C",
    planImage: "/assets/plan-2a-c.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2a-d",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "829 sq ft",
    balcony: "133–152 sq ft",
    bua: "1049–1068 sq ft",
    sbua: "1399–1424 sq ft",
    tower: "Tower 2A · Type D",
    planImage: "/assets/plan-2a-d.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2a-e",
    category: "3 BHK Smart",
    config: "3 BHK 2T (Smart)",
    carpet: "703 sq ft",
    balcony: "82–99 sq ft",
    bua: "854–871 sq ft",
    sbua: "1138–1162 sq ft",
    tower: "Tower 2A · Type E",
    planImage: "/assets/plan-2a-e.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2a-f",
    category: "3 BHK Comfort",
    config: "3 BHK 2T (Comfort)",
    carpet: "774 sq ft",
    balcony: "87–101 sq ft",
    bua: "938–951 sq ft",
    sbua: "1250–1268 sq ft",
    tower: "Tower 2A · Type F",
    planImage: "/assets/plan-2a-f.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2a-g",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "595 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 2A · Type G",
    planImage: "/assets/plan-2a-g.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "2a-h",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "879 sq ft",
    balcony: "147–157 sq ft",
    bua: "1109–1119 sq ft",
    sbua: "1479–1492 sq ft",
    tower: "Tower 2A · Type H",
    planImage: "/assets/plan-2a-h.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2b-a",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "877 sq ft",
    balcony: "146–157 sq ft",
    bua: "1106–1117 sq ft",
    sbua: "1475–1490 sq ft",
    tower: "Tower 2B · Type A",
    planImage: "/assets/plan-2b-a.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2b-b",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "596 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 2B · Type B",
    planImage: "/assets/plan-2b-b.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "2b-c",
    category: "3 BHK Comfort",
    config: "3 BHK 2T (Comfort)",
    carpet: "783 sq ft",
    balcony: "97 sq ft",
    bua: "955 sq ft",
    sbua: "1274 sq ft",
    tower: "Tower 2B · Type C",
    planImage: "/assets/plan-2b-c.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2b-d",
    category: "3 BHK Smart",
    config: "3 BHK 2T (Smart)",
    carpet: "703 sq ft",
    balcony: "82–99 sq ft",
    bua: "852–870 sq ft",
    sbua: "1136–1160 sq ft",
    tower: "Tower 2B · Type D",
    planImage: "/assets/plan-2b-d.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2b-e",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "826 sq ft",
    balcony: "154 sq ft",
    bua: "1065 sq ft",
    sbua: "1420 sq ft",
    tower: "Tower 2B · Type E",
    planImage: "/assets/plan-2b-e.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2b-f",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "823 sq ft",
    balcony: "138–159 sq ft",
    bua: "1050–1070 sq ft",
    sbua: "1400–1426 sq ft",
    tower: "Tower 2B · Type F",
    planImage: "/assets/plan-2b-f.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2b-g",
    category: "2 BHK",
    config: "2 BHK 2T",
    carpet: "597 sq ft",
    balcony: "60 sq ft",
    bua: "728 sq ft",
    sbua: "971 sq ft",
    tower: "Tower 2B · Type G",
    planImage: "/assets/plan-2b-g.jpg",
    note: "Carpet area approx. 595–597 sq ft depending on tower and type.",
  },
  {
    slug: "2b-h",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "874 sq ft",
    balcony: "146–157 sq ft",
    bua: "1108–1119 sq ft",
    sbua: "1477–1492 sq ft",
    tower: "Tower 2B · Type H",
    planImage: "/assets/plan-2b-h.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-a",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "942 sq ft",
    balcony: "109–123 sq ft",
    bua: "1133–1148 sq ft",
    sbua: "1511–1531 sq ft",
    tower: "Tower 2C · Type A",
    planImage: "/assets/plan-2c-a.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-b",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "942 sq ft",
    balcony: "110 sq ft",
    bua: "1135 sq ft",
    sbua: "1513 sq ft",
    tower: "Tower 2C · Type B",
    planImage: "/assets/plan-2c-b.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-c",
    category: "3 BHK Smart",
    config: "3 BHK 2T (Smart)",
    carpet: "698 sq ft",
    balcony: "99 sq ft",
    bua: "865 sq ft",
    sbua: "1153 sq ft",
    tower: "Tower 2C · Type C",
    planImage: "/assets/plan-2c-c.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-d",
    category: "3 BHK Comfort",
    config: "3 BHK 3T (Comfort)",
    carpet: "739 sq ft",
    balcony: "105–122 sq ft",
    bua: "916–934 sq ft",
    sbua: "1221–1245 sq ft",
    tower: "Tower 2C · Type D",
    planImage: "/assets/plan-2c-d.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-e",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "943 sq ft",
    balcony: "109 sq ft",
    bua: "1132 sq ft",
    sbua: "1510 sq ft",
    tower: "Tower 2C · Type E",
    planImage: "/assets/plan-2c-e.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-f",
    category: "3 BHK Luxury",
    config: "3 BHK 3T (Luxury)",
    carpet: "942 sq ft",
    balcony: "107–123 sq ft",
    bua: "1131–1147 sq ft",
    sbua: "1507–1530 sq ft",
    tower: "Tower 2C · Type F",
    planImage: "/assets/plan-2c-f.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-g",
    category: "3 BHK Comfort",
    config: "3 BHK 2T (Comfort)",
    carpet: "736 sq ft",
    balcony: "107–122 sq ft",
    bua: "913–928 sq ft",
    sbua: "1217–1237 sq ft",
    tower: "Tower 2C · Type G",
    planImage: "/assets/plan-2c-g.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
  {
    slug: "2c-h",
    category: "3 BHK Smart",
    config: "3 BHK 2T (Smart)",
    carpet: "698 sq ft",
    balcony: "83–98 sq ft",
    bua: "848–863 sq ft",
    sbua: "1131–1151 sq ft",
    tower: "Tower 2C · Type H",
    planImage: "/assets/plan-2c-h.jpg",
    note: "Balcony, BUA and SBUA vary by floor (odd/even sky terrace).",
  },
];
